<template>
    <div class="pagination">
        <div class="pagination-pre" @click="prevPage()">
            <chevron-left-icon size="1.5x" class="custom-class"></chevron-left-icon>
        </div>
        <div class="pagination-pages">
            <div class="pagination-page"
                 v-for="page in 6"
                 @click="selectPage(page)"
                 :class="{'pagination-selected': selected === page}"
            >
                {{ page }}
            </div>
        </div>
        <div class="pagination-next" @click="nextPage()">
            <chevron-right-icon size="1.5x" class="custom-class"></chevron-right-icon>
        </div>
    </div>
</template>

<script>
    import { ChevronLeftIcon, ChevronRightIcon } from 'vue-feather-icons'
    export default {
        name: "Pagination",
        components: {
            ChevronLeftIcon,
            ChevronRightIcon
        },
        data() {
            return {
                pages: [],
                selected: 1
            }
        },
        methods: {
            selectPage(page) {
                this.selected = page;
            },
            prevPage() {
                if(this.selected > 1) {
                    this.selected -= 1;
                }
            },
            nextPage() {
                if(this.selected <=5 ) {
                    this.selected += 1;
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .pagination {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        max-width: 288px;
        margin: auto;
        &-pages {
            display: flex;
            justify-content: space-between;
            width: 100%;
            margin: 0 25px;
        }
        &-page {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            line-height: 21px;
            color: #3F4450;
            width: 32px;
            height: 32px;
            cursor: pointer;
        }
        &-pre, &-next {
            display: flex;
            align-items: center;
            color: #3BA5A1;
            width: 42px;
            height: 32px;
            cursor: pointer;
            svg {
                width: 100%;
            }
        }
        &-selected {
            background: linear-gradient(86.51deg, #6BBCBA 0%, #3BA5A1 100%);
            border-radius: 50%;
            color: #FCFCFC;

        }
    }
</style>
